var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-container"},[_c('div',{staticClass:"com-chart",staticStyle:{"display":"flex"}},[_c('div',{ref:"seller_erf",staticStyle:{"width":"49.9%"}}),_c('div',{ref:"seller_erf1",staticStyle:{"width":"49.9%"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }